import { Injectable } from '@angular/core';

const logger = console;
let pageVisibilityService$: any;

@Injectable({
  providedIn: 'root'
})
export class PageVisibilityService {

  // main snippet source: https://www.html5rocks.com/en/tutorials/pagevisibility/intro/
  private visibilityListeners = [];

  private evtname = null;

  constructor() {
    pageVisibilityService$ = this;
  }

  private getHiddenProp() {
    const prefixes = ['webkit', 'moz', 'ms', 'o'];

    // if 'hidden' is natively supported just return it
    if ('hidden' in document) {
      return 'hidden';
    }

    // otherwise loop over all the known prefixes until we find one
    for (let i = 0; i < prefixes.length; i++) {
      if ((prefixes[i] + 'Hidden') in document) {
        return prefixes[i] + 'Hidden';
      }
    }

    // otherwise it's not supported
    return null;
  }

  isHidden() {
    const prop = pageVisibilityService$.getHiddenProp();
    if (!prop) {
      return false;
    }

    return document[prop];
  }

  private visChange() {

    const hidden = pageVisibilityService$.isHidden();

    for (let x = 0; x < pageVisibilityService$.visibilityListeners.length; x++) {
      pageVisibilityService$.visibilityListeners[x](hidden);
    }

  }

  startListeningForPageVisibility() {

    if (this.evtname !== null) { // done init, skip.
      return;
    }

    // use the property name to generate the prefixed event name
    const visProp = pageVisibilityService$.getHiddenProp();

    if (visProp) {
      this.evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange';
      document.addEventListener(this.evtname, this.visChange);
    } else {
      logger.error('Visibility API not supported by browser.');
    }

  }

  stopListeningForPageVisibility() {
    document.removeEventListener(this.evtname, this.visChange);
    this.evtname = null; // reset so we can enable it back via startListening..
  }

  /**
   * Listeners should execute as fast as possible.
   *
   * It is the responsibility of the listener to implement its own debounce logic so to avoid unnecessary repetitive
   * execution.
   *
   * At the moment, debounce will not be implemented here to allow the listeners to react in the shortest
   * possible time.
   * @param listener the listener
   */

  registerVisibilityListener(listener) {
    this.visibilityListeners.push(listener);
  }

  removeVisibilityListener(listener) {
    throw new Error('Unsupported operation exception.');
  }

}
